import React, { createContext, useState, useContext, ReactNode } from 'react';

interface SpinnerContextProps {
  loading: boolean;
  startLoading: () => void;
  stopLoading: () => void;
}

const SpinnerContext = createContext<SpinnerContextProps | undefined>(undefined);


interface SpinnerProviderProps {
  children: ReactNode;
}


export const SpinnerProvider: React.FC<SpinnerProviderProps> = ({ children }) => {
  const [loading, setLoading] = useState(false);

  const startLoading = () => setLoading(true);
  const stopLoading = () => setLoading(false);

  return (
    <SpinnerContext.Provider value={{ loading, startLoading, stopLoading }}>
      {children}
    </SpinnerContext.Provider>
  );
};

export const useSpinner = () => {
  const context = useContext(SpinnerContext);
  if (context === undefined) {
    throw new Error('useSpinner must be used within a SpinnerProvider');
  }
  return context;
};